/**
 * Traditional Chinese (TWD + HKD + USD) mock transactions. Transfer pairs
 * carry the same `paired*` fields the app's groupTransferPairs() produces,
 * so the real DoubleRow component renders the two-sided sublines. The
 * investment and credit-card payment pairs are cross-currency (TWD ↔ HKD).
 */

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_TRANSACTIONS_ZH_TW = [
	{
		id: 'txn-1',
		date: '2026-08-03',
		type: 'Deposit',
		amount: 112000,
		description: '薪水',
		accountId: 'acc-checking',
		accountName: '常綠銀行',
		currency: 'TWD',
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		tagNames: '收入',
	},
	{
		id: 'txn-2',
		isTransferPair: true,
		date: '2026-08-01',
		type: 'Transfer',
		amount: 16000,
		description: '存入儲蓄',
		accountId: 'acc-checking',
		accountName: '常綠銀行',
		currency: 'TWD',
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		tagNames: '儲蓄',
		pairedType: 'Transfer',
		pairedAmount: 16000,
		pairedCurrencySymbol: 'NT$',
		pairedCurrencyDecimalPlaces: 0,
		pairedAccountName: '定期存款',
		pairedAccountId: 'acc-savings',
		pairedDate: '2026-08-01',
	},
	{
		id: 'txn-3',
		isTransferPair: true,
		date: '2026-08-01',
		type: 'Regular Investment',
		amount: 124800,
		description: '基金定投',
		accountId: 'acc-checking',
		accountName: '常綠銀行',
		currency: 'TWD',
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		tagNames: '投資',
		pairedType: 'Regular Investment',
		pairedAmount: 32000,
		pairedCurrencySymbol: 'HK$',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: '成長型基金',
		pairedAccountId: 'acc-broker',
		pairedDate: '2026-08-01',
	},
	{
		id: 'txn-4',
		isTransferPair: true,
		date: '2026-07-20',
		type: 'Credit Card Payment',
		amount: 84318,
		description: '港島返利卡繳費',
		accountId: 'acc-checking',
		accountName: '常綠銀行',
		currency: 'TWD',
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		tagNames: '帳單',
		pairedType: 'Credit Card Payment',
		pairedAmount: 21620,
		pairedCurrencySymbol: 'HK$',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: '港島返利卡',
		pairedAccountId: 'acc-credit',
		pairedDate: '2026-07-20',
	},
	{
		id: 'txn-5',
		date: '2026-07-24',
		type: 'Withdrawal',
		amount: 6000,
		description: '提現',
		accountId: 'acc-checking',
		accountName: '常綠銀行',
		currency: 'TWD',
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		tagNames: '現金',
	},
	{
		id: 'txn-6',
		date: '2026-07-22',
		type: 'Purchase',
		amount: 1560,
		description: '超市',
		accountId: 'acc-credit',
		accountName: '港島返利卡',
		currency: 'HKD',
		currencySymbol: 'HK$',
		currencyDecimalPlaces: 2,
		tagNames: '餐飲',
	},
	{
		id: 'txn-7',
		date: '2026-07-18',
		type: 'Reward Earned',
		amount: 4200,
		description: '獲得哩程',
		accountId: 'acc-flight',
		accountName: '飛行哩程',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '哩程',
	},
];

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_AVIOS_TRANSACTIONS_ZH_TW = [
	{
		id: 'av-1',
		date: '2026-08-02',
		type: 'Reward Earned',
		amount: 5600,
		description: '飯店住宿獎勵',
		accountId: 'acc-flight',
		accountName: '飛行哩程',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '哩程',
	},
	{
		id: 'av-2',
		date: '2026-07-28',
		type: 'Reward Redemption',
		amount: 20000,
		description: '獎勵機票（經濟艙）',
		accountId: 'acc-flight',
		accountName: '飛行哩程',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '旅行',
	},
	{
		id: 'av-3',
		date: '2026-07-18',
		type: 'Reward Earned',
		amount: 4200,
		description: '航班獎勵',
		accountId: 'acc-flight',
		accountName: '飛行哩程',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '哩程',
	},
];
